import { IntakePetSectionQuestionModel, QuestionModel } from '@common/models';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';

export type ComboQuestionTypeProps = {
  questionName: string;
  followupQuestionName: string;
  isPreview: boolean;
  question: IntakePetSectionQuestionModel | QuestionModel;
  onQuestionChange: (val: boolean) => void;
  onFollowupChange: (val: string) => void;
};

export function ComboQuestionType({
  questionName,
  followupQuestionName,
  question,
  onQuestionChange,
  onFollowupChange,
  isPreview = false,
}: ComboQuestionTypeProps) {
  const [showFollowUp, setShowFollowUp] = useState<boolean | undefined>(
    question instanceof IntakePetSectionQuestionModel
      ? question.bitValue
      : undefined,
  );
  const [followUpValue, setFollowUpValue] = useState(
    question instanceof IntakePetSectionQuestionModel
      ? question.stringValue
      : '',
  );

  return (
    <>
      <Form.Check
        inline
        name={questionName}
        label={question.yesOverrideText || 'Yes'}
        type="radio"
        checked={showFollowUp === true}
        disabled={question.isReadOnly}
        onChange={(e) => {
          if (e.target.checked) {
            setShowFollowUp(true);
            onQuestionChange(true);
          }
        }}
      />

      <Form.Check
        inline
        name={questionName}
        label={question.noOverrideText || 'No'}
        type="radio"
        checked={showFollowUp === false}
        disabled={question.isReadOnly}
        onChange={(e) => {
          if (e.target.checked) {
            setShowFollowUp(false);
            onQuestionChange(false);
          }
        }}
      />

      {showFollowUp === question.showFollowupWhenAnswerIs ? (
        <div className="mt-2">
          <Form.Label
            className={`ps-0 mb-0 ${!question.isFollowupReadOnly ? 'question' : ''}`}
            dangerouslySetInnerHTML={{ __html: question.followupQuestion }}
          ></Form.Label>
          {!question.isFollowupReadOnly ? (
            <Form.Control
              type="text"
              value={followUpValue}
              name={followupQuestionName}
              disabled={question.isReadOnly}
              onChange={(e) => {
                setFollowUpValue(e.target.value);
                onFollowupChange(e.target.value);
              }}
            />
          ) : null}
        </div>
      ) : null}
    </>
  );
}
